// @flow

import * as urls from '../urls';
import * as request from 'app/utils/request';

export const subscriptionStatusFetcher = (
  object_id: number,
  content_type: 'procedure' | 'proceduregroup' | 'policy' | 'tasktemplate'
) => request.get(urls.THREAD_API_URL, {object_id, content_type});

export const unsubscribeFetcher = (url: string) => request.del(url);

export const subscribeFetcher = (
  object_id: number,
  content_type: 'procedure' | 'proceduregroup' | 'policy' | 'tasktemplate'
) => request.postJson(urls.THREAD_API_URL, {object_id, content_type});
